
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'load-more-popover'
})
export default class extends Vue {
    @Prop({ default: false }) private hasData!: boolean
    @Prop({ default: '' }) private width!: number
    @Prop({ default: false }) private isFocus!: boolean

    private visible = false
    private popverWidth = ''
    private fetchLoading = false

    mounted() {
        this.calcPopverWidth()
        this.listenBodyClick()
    }
    calcPopverWidth() {
        if (this.popverWidth) return
        this.popverWidth = (this.$refs.referenceRef as any).clientWidth
    }
    listenBodyClick() {
        document.documentElement.addEventListener('click', this.closeCustomPopover)
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('click', this.closeCustomPopover)
        })
    }
    // document 事件，关闭自定义弹出层
    closeCustomPopover(event: any) {
        if (!this.visible || this.isFocus) return
        const { target } = event
        const popver = (this.$refs.customPopover as any).popperElm
        if (!popver) return
        const isContain = popver.contains(target)
        if (!isContain) {
            // 关闭 popver
            this.close()
        }
    }
    show() {
        this.visible = true
    }
    close() {
        this.visible = false
    }
    showLoading() {
        this.fetchLoading = true
    }
    hideLoading() {
        this.fetchLoading = false
    }
}
